/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function NewMediaProfileModal (_) {

	var self = this;

	self.selectedMediaProfileType = null;

	self.$onInit = function () {
		self.availableProfileTypes = ['VIDEO', 'IMAGE', 'AUDIO', 'ARTWORK', 'DOCUMENT'];
	};

	self.canCreate = function () {
		return self.selectedMediaProfileType !== null;
	};

	self.onCreate = function () {
		self.close({$value: self.selectedMediaProfileType});
	};

	self.onCancel = function () {
		self.dismiss({$value: 'cancel'});
	};

}

angular.module('prism-ui.mediaAcceptProfiles').component('newMediaProfileModal', {
	templateUrl: 'system/templates/mediaAcceptProfiles/modals/new-media-profile-modal-template.html',
	controller: NewMediaProfileModal,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});
